import { useCallback, useEffect, useState } from 'react'
import { Menu } from '@material-ui/core'
import ArrowDropdown from 'assets/icons/ArrowDropdown'
import { IDropdownOption, TStringOrNumber } from 'models/shared.models'
import Button from '../Button/Button'
import './styles.scss'

export interface SydButtonListProps {      
  disabled?: boolean
  label: string
  loading?: boolean
  menuDirection: "top" | "bottom"
  options: Readonly<IDropdownOption[]>
  drawerStyle?: "primary"
  handleClickedOption: (value: TStringOrNumber) => void
}

const SydButtonList = (props: SydButtonListProps) => {
  const { disabled, label, loading, options, handleClickedOption, menuDirection, drawerStyle } = props
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [showOptions, setShowOptions] = useState<boolean>(false)

  const handleClick = useCallback((e: any) => {
    setAnchorEl(e.currentTarget)
    setShowOptions(true)
  }, [])

  const handleOptionClick = useCallback(
    (value: TStringOrNumber) => {
      setAnchorEl(null)
      setShowOptions(false)
      handleClickedOption(value)
    },
    [handleClickedOption]
  )

  useEffect(() => {
    if (loading) {
      setAnchorEl(null)
      setShowOptions(false)
    }
  }, [loading])

  return (
    <div className="syd-button-list">
      <Button
        type="button"
        color="secondary"
        variant={drawerStyle === "primary" ? "contained" : "outlined"}
        disabled={disabled}
        onClick={handleClick}
        endIcon={<ArrowDropdown />}
        activity={loading}>
        {label}
      </Button>

      <Menu
        anchorEl={anchorEl}
        keepMounted
        className={`syd-button-list-menu ${drawerStyle}`}
        open={Boolean(anchorEl) && showOptions}
        onClose={() => {
          setAnchorEl(null)
          setShowOptions(false)
        }}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: menuDirection, horizontal: 'left' }}
        transformOrigin={{ vertical: menuDirection === "top" ? "bottom" : "top", horizontal: 'left' }}
        PaperProps={{ style: { maxHeight: 43.5 + 33 * 10.5 } }}>
        <div className="syd-button-list-menu-content">
          {options.map(({ id, label, value, disabled }) => (
            <span
              key={id}
              className={disabled ? 'disabled' : ''}
              onClick={() => (!disabled ? handleOptionClick(value) : null)}>
              {label}
            </span>
          ))}
        </div>
      </Menu>
    </div>
  )
}

export default SydButtonList
